import className from 'classnames/bind';
import styles from './RelatedPosts.module.scss';
import { Container, Grid, Heading, PostsEntry } from '@/components';

let cx = className.bind(styles);

export function RelatedPosts({ relatedPosts, categories }) {
	const displayedPosts = [];

	if (relatedPosts) {
		for (const post of relatedPosts) {
			if (displayedPosts.length >= 3) break;
			displayedPosts.push(post);
		}
	}

	for (const category of categories) {
		if (displayedPosts.length >= 3 || category.name.toLowerCase() === 'uncategorized') break;
		for (const post of category.posts?.nodes) {
			if (displayedPosts.length >= 3) break;
			displayedPosts.push(post);
		}
	}

	return (
		<>
			{displayedPosts.length > 0 && (
				<section className={cx(['ns_related-posts', 'related-posts'])}>
					<Container>
						<Heading level="h2" className={cx(['title'])}>
							Related articles
						</Heading>
						<Grid className={cx(['related-post-grid'])} colCount={3} collapseMobile={false}>
							{displayedPosts.map((post) => (
								<PostsEntry key={post.id} title={post.title} uri={post.uri} featuredImage={post.featuredImage} excerpt={post.excerpt} imageSizes='(max-width: 500px) 50vw, (max-width: 820px) 220px, (max-width: 1600px) 25vw, 340px' />
							))}
						</Grid>
					</Container>
				</section>
			)}
		</>
	);
}
